var _g, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 13.229 13.229",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Lock",
    transform: "matrix(.2706 0 0 .25409 74.805 107.75)",
    strokeWidth: 1.009
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-237.7-401.3h-3v-6.4c0-6.2-5.1-11.3-11.3-11.3s-11.3 5.1-11.3 11.3v6.4h-3v-6.4c0-7.9 6.4-14.3 14.3-14.3s14.3 6.4 14.3 14.3v6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-239.2-374.1h-25.6c-2.6 0-4.8-2.2-4.8-4.8v-19.2c0-2.6 2.2-4.8 4.8-4.8h25.6c2.6 0 4.8 2.2 4.8 4.8v19.2c0 2.7-2.2 4.8-4.8 4.8zm-25.6-25.6c-0.9 0-1.6 0.7-1.6 1.6v19.2c0 0.9 0.7 1.6 1.6 1.6h25.6c0.9 0 1.6-0.7 1.6-1.6v-19.2c0-0.9-0.7-1.6-1.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-248.8-393.3c0 1.8-1.4 3.2-3.2 3.2s-3.2-1.4-3.2-3.2 1.4-3.2 3.2-3.2 3.2 1.5 3.2 3.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "-251.2 -393.3 -252.8 -393.3 -254.4 -383.7 -249.6 -383.7 -251.2 -393.3"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#fff;}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.51224820a8e4feacfbd51e9158bf33fa.svg";
export { ForwardRef as ReactComponent };